module.exports = __webpack_public_path__ + "static/media/settings.5c063934.svg";